import React from 'react'
import { UploadFieldBlock } from '../../blocks'
import Title from '../upload/field-title'
import TextFieldAsync from 'shared/components/edit-panel/info/textfield-async'
import CreationToolUploadField from '../../../types/upload-field'

type Props = {
    className?: string
    field: CreationToolUploadField
    sourceUrl?: string
    onChange: (sourceUrl: string) => void
}

const CreationSourceURLField = ({ className, field, sourceUrl = '', onChange }: Props) => {
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    return (
        <UploadFieldBlock className={className}>
            <Title field={field} />
            <TextFieldAsync
                value={sourceUrl}
                title={'Source URL'}
                isURL={true}
                placeholder={'Add a source URL'}
                maxLength={maxLength}
                onChange={(ctaUrl: string) => onChange(ctaUrl)}
                includeTitle={false}
            />
        </UploadFieldBlock>
    )
}

export default CreationSourceURLField
